import formatDate from '../../../../../../../components/common/formatDate';
import TableCompHead from '../../../../../../../components/ui/TableCompHead';

interface IProps {
  moduleData: any;
}
type revisionObj = {
  rev_no: number;
  summary: string;
  [key: string]: string | number;
};

const THead = ({ moduleData }: IProps) => {
  return (
    <thead>
      <TableCompHead
        colSpan={3}
        rowSpan={1}
        labels={[]}
        values={[]}
        heading=""
      />
      <tr>
        {['Topic No.', 'Topic Type', 'Topic Name'].map((item) => (
          <th
            align="center"
            style={{
              border: '1px solid black',
              textAlign: 'center',
              height: '50px',
              width: item === 'Topic Name' ? '800px' : '',
            }}
          >
            {item}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
